import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Client } from '../models/client';
import { ProfileService } from '../services/profile.service';
import { PlansService } from '../services/plans.service';
import { ContextService } from '../services/context/context.service';

export const ClientResolver: ResolveFn<any> = async (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  contextService: ContextService = inject(ContextService),
  profileService: ProfileService = inject(ProfileService),
  plansService: PlansService = inject(PlansService)
): Promise<Client | any> => {
  const client = await contextService.loadClient(route, profileService.getFixedClientId());
  if (client) {
    client.plan = await plansService.getClientPlan(client.id);
  }
  return client;
};
